<template>
  <el-dialog
      title="修改备注"
      :visible.sync="dialogVisible"
      width="520px"
      append-to-body
      class="custom-el-wrapper"
      @closed="handleClosed"
  >
    <div v-if="orderId" class="arm-tab-head">
      <button
          type="button"
          class="arm-tab-btn"
          :class="{ 'is-active': activeTab === 'order' }"
          @click="switchTab('order')"
      >
        订单备注
      </button>
      <button
          type="button"
          class="arm-tab-btn"
          :class="{ 'is-active': activeTab === 'aftersale' }"
          @click="switchTab('aftersale')"
      >
        售后备注
      </button>
    </div>

    <div v-if="orderId" v-show="activeTab === 'order'" v-loading="orderRemarkLoading" class="arm-pane">
      <div class="arm-form-row">
        <span class="arm-label">订单标记</span>
        <div class="arm-field">
          <el-radio-group v-model="orderForm.seller_remark_stars" class="arm-star-group">
            <el-radio
                v-for="(star, index) in orderForm.arr_star"
                :key="'st-' + index + '-' + star.val"
                :label="star.val"
                class="arm-star-radio"
            >
              <i
                  class="arm-star-icon"
                  :class="star.icon || 'el-icon-s-flag'"
                  :style="{ color: star.color || '#c0c4cc' }"
              />
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="arm-form-row arm-form-row--block">
        <span class="arm-label">订单备注</span>
        <div class="arm-field" style="width: 100%;">
          <el-input
              style="width: 100%;"
              v-model="orderForm.seller_words"
              type="textarea"
              :rows="5"
              maxlength="500"
              show-word-limit
              placeholder="请输入订单备注信息，此备注不对用户展示"
          />
        </div>
      </div>
    </div>

    <div v-show="!orderId || activeTab === 'aftersale'" class="arm-pane">
      <el-form ref="aftersaleFormRef" :model="aftersaleForm" :rules="aftersaleRules" label-width="0">
        <el-form-item prop="remark">
          <el-input
              v-model="aftersaleForm.remark"
              type="textarea"
              :rows="6"
              maxlength="500"
              show-word-limit
              placeholder="请输入售后备注内容（必填）"
          />
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" :loading="submitting" @click="submit">提 交</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AftersaleRemarkDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    /** 本地 order_after_sales.id */
    aftersaleId: {
      type: Number,
      default: 0
    },
    /** 主订单 id，用于订单备注接口 */
    orderId: {
      type: Number,
      default: 0
    },
    /** 打开时默认选中的页签：order | aftersale */
    initialTab: {
      type: String,
      default: 'aftersale'
    },
    /** 已有售后备注（回填） */
    initialRemark: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeTab: 'aftersale',
      orderRemarkLoading: false,
      orderForm: {
        arr_star: [],
        seller_remark_stars: '',
        seller_words: ''
      },
      aftersaleForm: {
        remark: ''
      },
      submitting: false,
      aftersaleRules: {
        remark: [
          {
            validator(rule, value, callback) {
              if (!value || !String(value).trim()) {
                callback(new Error('请输入售后备注内容'));
                return;
              }
              callback();
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        let tab = this.initialTab === 'order' ? 'order' : 'aftersale';
        if (tab === 'order' && !this.orderId) {
          tab = 'aftersale';
        }
        this.activeTab = tab;
        const raw = this.initialRemark != null ? String(this.initialRemark) : '';
        this.aftersaleForm.remark = raw.trim() ? raw : '';
        this.$nextTick(() => {
          if (this.$refs.aftersaleFormRef) {
            this.$refs.aftersaleFormRef.clearValidate();
          }
        });
        if (this.orderId) {
          this.loadOrderRemark();
        } else {
          this.orderForm = { arr_star: [], seller_remark_stars: '', seller_words: '' };
        }
      }
    }
  },
  methods: {
    ...mapActions({
      opDdAftersaleAddRemark: 'ucenter_order/opDdAftersaleAddRemark',
      getOrderManageRemarkInfo: 'ucenter_order/getOrderManageRemarkInfo',
      opOrderManageAddRemark: 'ucenter_order/opOrderManageAddRemark'
    }),
    switchTab(name) {
      this.activeTab = name;
      if (name === 'order' && this.orderId && !this.orderRemarkLoading && !this.orderForm.arr_star.length) {
        this.loadOrderRemark();
      }
    },
    loadOrderRemark() {
      if (!this.orderId) return;
      this.orderRemarkLoading = true;
      this.getOrderManageRemarkInfo({
        data: { order_id: this.orderId },
        success: (res) => {
          this.orderRemarkLoading = false;
          if (res.code === 200) {
            this.orderForm.arr_star = Array.isArray(res.data.arr_star) ? res.data.arr_star : [];
            this.orderForm.seller_remark_stars = res.data.seller_remark_stars;
            this.orderForm.seller_words = res.data.seller_words != null ? String(res.data.seller_words) : '';
          } else {
            this.$message.error(res.msg || '获取订单备注失败');
          }
        }
      });
    },
    handleClosed() {
      this.activeTab = 'aftersale';
      this.aftersaleForm.remark = '';
      this.orderForm = { arr_star: [], seller_remark_stars: '', seller_words: '' };
      this.submitting = false;
      this.orderRemarkLoading = false;
    },
    submit() {
      if (this.activeTab === 'order') {
        this.submitOrderRemark();
      } else {
        this.submitAftersaleRemark();
      }
    },
    submitOrderRemark() {
      if (!this.orderId) {
        this.$message.warning('缺少订单 id');
        return;
      }
      this.submitting = true;
      const param = {
        order_id: this.orderId,
        seller_remark_stars: this.orderForm.seller_remark_stars,
        seller_words: this.orderForm.seller_words
      };
      this.opOrderManageAddRemark({
        data: param,
        success: (res) => {
          this.submitting = false;
          if (res.code === 200) {
            this.$message.success(res.msg || '保存成功');
            this.dialogVisible = false;
            this.$emit('success', { tab: 'order' });
          } else {
            this.$message.error(res.msg || '保存失败');
          }
        }
      });
    },
    submitAftersaleRemark() {
      if (!this.aftersaleId) {
        this.$message.warning('缺少售后记录 id');
        return;
      }
      this.$refs.aftersaleFormRef.validate((valid) => {
        if (!valid) return;
        const remark = String(this.aftersaleForm.remark).trim();
        this.submitting = true;
        this.opDdAftersaleAddRemark({
          data: { id: this.aftersaleId, remark },
          success: (res) => {
            this.submitting = false;
            if (res.code === 200) {
              this.$message.success(res.msg || '提交成功');
              this.dialogVisible = false;
              this.$emit('success', { tab: 'aftersale' });
            } else {
              this.$message.error(res.msg || '提交失败');
            }
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.arm-tab-head {
  display: flex;
  gap: 0;
  margin: -6px 0 16px;
  border-bottom: 1px solid #ebeef5;
}
.arm-tab-btn {
  flex: 1;
  padding: 10px 12px;
  font-size: 14px;
  color: #909399;
  background: #f5f7fa;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  margin-bottom: -1px;
  transition: color 0.15s, background 0.15s;
}
.arm-tab-btn.is-active {
  color: #1966ff;
  font-weight: 600;
  background: #fff;
  border-bottom-color: #1966ff;
}
.arm-pane {
  min-height: 120px;
}
.arm-form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.5;
}
.arm-form-row--block {
  flex-direction: column;
  gap: 8px;
}
.arm-form-row--block .arm-label {
  min-width: 0;
}
.arm-label {
  min-width: 80px;
  color: #606266;
  padding-top: 4px;
}
.arm-field {
  flex: 1;
  min-width: 0;
}
.arm-star-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
}
.arm-star-radio {
  margin-right: 0;
  margin-bottom: 4px;
}
.arm-star-icon {
  font-size: 16px;
  vertical-align: middle;
}
.arm-tip {
  font-size: 13px;
  color: #909399;
  margin: 0 0 12px;
}
</style>

<style>
.aftersale-remark-dialog .el-dialog__body {
  padding-top: 12px;
}
.aftersale-remark-dialog .arm-star-radio .el-radio__label {
  padding-left: 6px;
}
.aftersale-remark-dialog .el-radio__input.is-checked + .el-radio__label {
  color: #1966ff;
}
.aftersale-remark-dialog .el-radio__input.is-checked .el-radio__inner {
  background-color: #1966ff;
  border-color: #1966ff;
}
.aftersale-remark-dialog .el-textarea__inner:focus {
  border-color: #1966ff;
}
</style>
